import {
  INVITEE_RESET,
  INVITEE_AUTHORIZED,
  INVITEE_ID_UPDATED,
  INVITEE_NAMES_UPDATED,
  INVITEE_REGION_UPDATED,
  INVITEE_EVENTS_UPDATED,
  INVITEE_ATTENDEES_UPDATED,
  INVITEE_INVITATION_UPDATED,
  INVITEE_BA_UPDATED,
} from '../actions/actionTypes';

const initialState = {
  authorized: false,
  events: {
    ny: [],
    ca: [],
  },
  names: ['Brycen Dorsay', 'Jillian Spies'],
  region: 'other',
  invitation_style: 'traditional',
  id: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INVITEE_RESET:
      return initialState;
    case INVITEE_ID_UPDATED:
      return {
        ...state,
        id: action.id,
      };
    case INVITEE_AUTHORIZED:
      return {
        ...state,
        authorized: action.authorized,
      };
    case INVITEE_REGION_UPDATED:
      return {
        ...state,
        region: action.region,
      };
    case INVITEE_BA_UPDATED:
      return {
        ...state,
        ba: action.ba,
      };
    case INVITEE_EVENTS_UPDATED:
      return {
        ...state,
        events: action.events,
      };
    case INVITEE_INVITATION_UPDATED:
      return {
        ...state,
        invitation_style: action.invitation_style,
      };
    case INVITEE_NAMES_UPDATED:
      return {
        ...state,
        names: action.names,
      };
    case INVITEE_ATTENDEES_UPDATED:
      return {
        ...state,
        attendees: action.attendees,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/invitee.js